export default {
  title: 'Aplicação móvel',
  fields: {
    name: 'Nome da aplicação',
  },
  buttons: {
    save: 'Guardar',
  },
};
